import { Component, computed, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CmdbHomeScreenService } from 'src/app/page/cmdb/cmdb-home-screen/service/cmdb-home-screen.service';
import { SearchInputComponent, searchInputTagsInterface } from 'src/app/page_component_item/search-input/search-input.component';
import { SearchInputModule } from 'src/app/page_component_item/search-input/search-input.module';
import { ciInterface2 } from 'src/app/util/interfaces/ci';
import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { CommonModule } from '@angular/common';
import { SvgGearsModule } from 'src/app/page_component_item/svg-gears/svg-gears.module';
import { Subscription } from 'rxjs';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';
import { SquarePostLoadingEffectComponent } from 'src/app/page_component_item/square-post-loading-effect/square-post-loading-effect.component';

@Component({
	selector: 'pcp-cmdb-search-gadget',
	standalone: true,
	imports: [CommonModule, SearchInputModule, SvgGearsModule, SquarePostLoadingEffectComponent],
	templateUrl: './cmdb-search-gadget.component.html',
	styleUrls: ['../../page_component_item/msp-cmdb-table-like/msp-cmdb-table-like.component.scss', './cmdb-search-gadget.component.scss'],
})
export class CmdbSearchGadgetComponent implements OnInit {
	private labelsService = inject(LabelsService);
	private CmdbHomeScreenService = inject(CmdbHomeScreenService);
	labels: LabelsInterface = {};

	@Input() ignoreCiList: string = null;
	@Input() allowedCiTypeList: string = null;
	@Input() loadOnInit = true;

	@Output() getCi = new EventEmitter<ciInterface2>();

	constructor() {
		this.labels = computed(() => this.labelsService.labels())();
	}

	isLoadingCiArr = false;
	showTable = false;

	@ViewChild('searchInput') searchInput: SearchInputComponent;

	searchReq: Subscription;
	searchTags: searchInputTagsInterface[] = [];
	searchParams = {
		general: '',
		field: [''],
		values: [[]],
		filter: [''],
	};
	selectedTag: searchInputTagsInterface;

	ciArr: ciInterface2[] = [];

	ngOnInit(): void {
		this.CmdbHomeScreenService.getAvailableCMDBViewColumns(this.allowedCiTypeList).subscribe({
			next: (cmdbHeaders) => {
				cmdbHeaders[0].items.forEach((header: genericFormI) => {
					const searchTag: searchInputTagsInterface = {
						tag: header.name,
						placeholder_label: header.label,
						label: header.label,
						items: header.items,
						icon: '',
					};

					this.searchTags.push(searchTag);
				});
			},
		});

		if (this.loadOnInit) {
			this.CmdbHomeScreenService.searchCITable({
				page: 1,
				searchParameters: this.searchParams,
				sortBy: 'id',
				sortDown: true,
				recount: false,
				showInactiveCis: false,
				noItemsSearch: true,
				includeField: null,
				ignoreCiList: this.ignoreCiList,
				allowedCiTypeList: this.allowedCiTypeList,
			}).subscribe({
				next: (cmdbArray) => {
					this.ciArr = cmdbArray.ciArr;
					this.showTable = true;
					this.isLoadingCiArr = false;
				},
			});
		} else {
			this.isLoadingCiArr = false;
		}
	}

	searchCis(tag: searchInputTagsInterface, text: string): void {
		this.isLoadingCiArr = true;
		if (this.searchReq) this.searchReq.unsubscribe();

		let parameter = ['general'];
		if (tag == undefined || !['id', 'identification', 'type'].includes(tag.tag)) this.selectedTag = tag;
		if (tag != undefined) parameter = [tag.tag];
		const sortBy = tag == undefined ? 'id' : tag.tag;

		const searchParameters = { [tag?.tag ?? 'general']: text };

		this.searchReq = this.CmdbHomeScreenService.searchCITable({
			page: 1,
			searchParameters: searchParameters,
			sortBy: sortBy,
			sortDown: true,
			recount: false,
			showInactiveCis: false,
			noItemsSearch: true,
			includeField: parameter.join(','),
			ignoreCiList: this.ignoreCiList,
			allowedCiTypeList: this.allowedCiTypeList,
		}).subscribe({
			next: (cmdbArray) => {
				this.ciArr = cmdbArray.ciArr;
				this.showTable = true;
				this.isLoadingCiArr = false;
			},
		});
	}

	emitCi(ci: ciInterface2): void {
		this.getCi.emit(ci);
	}

	reset(): void {
		if (this.searchReq) {
			this.searchReq.unsubscribe();
		}

		this.ciArr = [];
		this.showTable = false;

		this.searchParams = {
			general: '',
			field: [''],
			values: [[]],
			filter: [''],
		};

		if (this.searchInput) {
			this.searchInput.searchText = '';
			this.searchInput.selectedSearchTag = undefined;
			this.searchInput.searchPlaceholder = 'lbl_geral_pesquisar';
			this.searchInput.openList = false;
		}
	}
}
